module.exports = "/_next/static/images/SergiuRobu-ea2716d5d2e1689113d5f5ab970257ad.webp";